/* eslint-disable camelcase */
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { handleMessages } from '../_helpers/utilities'
import { IPhoneDetails } from '../_models/businessInterface'
import { OtpData, OtpState } from '../_models/otpInterface'
import otpServices from '../_services/otpServices'
import { RootState } from '../_store/store'
import { startLoader, stopLoader } from './loaderSlice'
import { errorToast, successToast } from './toastSlice'
import { getProfileInformation, userDetails } from './userSlice'
const initialState: OtpState = {
  isModalOpen: false,
  isSuccessModalOpen: false,
  receive_sms: false,
  receive_whatsapp: false,
  wrongNumberData: null,
}
export const getOtp = createAsyncThunk(
  '/phones/verification',
  async (_, { dispatch, rejectWithValue }) => {
    dispatch(startLoader())
    try {
      const response = await otpServices.getOtp()
      dispatch(stopLoader())
      dispatch(successToast(handleMessages(response?.message)))
      dispatch(setModalOpen(true))

      return response
    } catch (err: any) {
      dispatch(stopLoader())
      dispatch(errorToast(handleMessages(err?.message)))
      return rejectWithValue(err)
    }
  },
)

export const verify = createAsyncThunk(
  '/verifyOtp',
  async (otpData: OtpData, { dispatch, rejectWithValue }) => {
    dispatch(startLoader())
    try {
      const response = await otpServices.verifyOtp(otpData)
      dispatch(stopLoader())
      dispatch(successToast(handleMessages(response?.message)))
      dispatch(userDetails())

      dispatch(setSuccessModalOpen(true))
      return response
    } catch (err: any) {
      dispatch(stopLoader())
      dispatch(errorToast(handleMessages(err?.message)))
      return rejectWithValue(err.message)
    }
  },
)
export const enableWtsp = createAsyncThunk(
  '/enableWtsp',
  async (wtspData: { receive_whatsapp: boolean }, { dispatch, rejectWithValue }) => {
    dispatch(startLoader())
    try {
      // eslint-disable-next-line camelcase

      const response = await otpServices.enableWtsp(wtspData)
      dispatch(stopLoader())
      dispatch(successToast(handleMessages(response?.message)))
      dispatch(userDetails())

      return response
    } catch (err: any) {
      dispatch(stopLoader())
      dispatch(errorToast(handleMessages(err?.message)))
      return rejectWithValue(err.message)
    }
  },
)
export const enableSms = createAsyncThunk(
  '/enableSms',
  async (smsData: { receive_sms: boolean }, { dispatch, rejectWithValue }) => {
    dispatch(startLoader())
    try {
      // eslint-disable-next-line camelcase

      const response = await otpServices.enableSMS(smsData)
      dispatch(stopLoader())
      dispatch(successToast(handleMessages(response?.message)))
      dispatch(userDetails())

      return response
    } catch (err: any) {
      dispatch(stopLoader())
      dispatch(errorToast(handleMessages(err?.message)))
      return rejectWithValue(err.message)
    }
  },
)
export const resendOtp = createAsyncThunk(
  '/phones/verification/resend',
  async (_, { dispatch, rejectWithValue }) => {
    dispatch(startLoader())
    try {
      const response = await otpServices.resendOtp()
      dispatch(stopLoader())
      dispatch(successToast(handleMessages(response?.message)))

      return response
    } catch (err: any) {
      dispatch(stopLoader())
      dispatch(errorToast(handleMessages(err?.message)))
      dispatch(setModalOpen(false))
      return rejectWithValue(err)
    }
  },
)
export const wrongNumber = createAsyncThunk(
  '/wrongNumber',
  async (params: IPhoneDetails, { dispatch, rejectWithValue }) => {
    dispatch(startLoader())
    try {
      const response = await otpServices.wrongNumber(params)
      dispatch(stopLoader())
      dispatch(successToast(handleMessages(response?.message)))
      dispatch(getProfileInformation())
      return response
    } catch (err: any) {
      dispatch(stopLoader())
      dispatch(errorToast(handleMessages(err?.message)))
      return rejectWithValue(err)
    }
  },
)
const otpSlice = createSlice({
  name: 'verifyOtp',
  initialState,

  reducers: {
    setModalOpen(state, action) {
      state.isModalOpen = action.payload
      if (!action.payload) {
        state.wrongNumberData = null
      }
    },
    setSuccessModalOpen(state, action) {
      state.isSuccessModalOpen = action.payload
    },
  },
  extraReducers: (builder) => {
    builder.addCase(wrongNumber.fulfilled, (state: any, action: any) => {
      state.wrongNumberData = action.payload.data
    })
  },
})

export const { setModalOpen, setSuccessModalOpen } = otpSlice.actions

export const otpData = (state: RootState) => state.verifyOtp

export default otpSlice.reducer
